import {
  getDocuments,
  getTSBDocuments,
  getDocumentsUpload,
  getDocumentTypes,
  getDocumentLanguages,
  getTsbDocumentLanguages,
  getDocumentCategories,
  getAdminDocumentModels,
  postDocument,
  putDocument,
  putDocumentFile,
  putDocumentExternalFile,
  deleteDocument,
  deleteDocumentFile,
  deleteDocumentExternalFile,
} from '../utils/requests/documentsApi'
import { getDocumentModels } from '../utils/requests/productsAPI'

export const LOAD_DOCUMENTS = 'LOAD_DOCUMENTS'
export const LOAD_DOCUMENTS_PENDING = 'LOAD_DOCUMENTS_PENDING'
export const LOAD_DOCUMENTS_FULFILLED = 'LOAD_DOCUMENTS_FULFILLED'
export const LOAD_DOCUMENTS_REJECTED = 'LOAD_DOCUMENTS_REJECTED'

export const LOAD_NEW_DOCUMENTS = 'LOAD_NEW_DOCUMENTS'
export const LOAD_NEW_DOCUMENTS_PENDING = 'LOAD_NEW_DOCUMENTS_PENDING'
export const LOAD_NEW_DOCUMENTS_FULFILLED = 'LOAD_NEW_DOCUMENTS_FULFILLED'
export const LOAD_NEW_DOCUMENTS_REJECTED = 'LOAD_NEW_DOCUMENTS_REJECTED'

export const LOAD_TSB_DOCUMENTS = 'LOAD_TSB_DOCUMENTS'
export const LOAD_TSB_DOCUMENTS_PENDING = 'LOAD_TSB_DOCUMENTS_PENDING'
export const LOAD_TSB_DOCUMENTS_FULFILLED = 'LOAD_TSB_DOCUMENTS_FULFILLED'
export const LOAD_TSB_DOCUMENTS_REJECTED = 'LOAD_TSB_DOCUMENTS_REJECTED'

export const LOAD_NEW_TSB_DOCUMENTS = 'LOAD_NEW_TSB_DOCUMENTS'
export const LOAD_NEW_TSB_DOCUMENTS_PENDING = 'LOAD_NEW_TSB_DOCUMENTS_PENDING'
export const LOAD_NEW_TSB_DOCUMENTS_FULFILLED = 'LOAD_NEW_TSB_DOCUMENTS_FULFILLED'
export const LOAD_NEW_TSB_DOCUMENTS_REJECTED = 'LOAD_NEW_TSB_DOCUMENTS_REJECTED'

export const LOAD_DASHBOARD_TSB_DOCUMENTS = 'LOAD_DASHBOARD_TSB_DOCUMENTS'
export const LOAD_DASHBOARD_TSB_DOCUMENTS_PENDING = 'LOAD_DASHBOARD_TSB_DOCUMENTS_PENDING'
export const LOAD_DASHBOARD_TSB_DOCUMENTS_FULFILLED = 'LOAD_DASHBOARD_TSB_DOCUMENTS_FULFILLED'
export const LOAD_DASHBOARD_TSB_DOCUMENTS_REJECTED = 'LOAD_DASHBOARD_TSB_DOCUMENTS_REJECTED'

export const LOAD_DOCUMENTS_UPLOAD = 'LOAD_DOCUMENTS_UPLOAD'
export const LOAD_DOCUMENTS_UPLOAD_PENDING = 'LOAD_DOCUMENTS_UPLOAD_PENDING'
export const LOAD_DOCUMENTS_UPLOAD_FULFILLED = 'LOAD_DOCUMENTS_UPLOAD_FULFILLED'
export const LOAD_DOCUMENTS_UPLOAD_REJECTED = 'LOAD_DOCUMENTS_UPLOAD_REJECTED'

export const LOAD_NEW_DOCUMENTS_UPLOAD = 'LOAD_NEW_DOCUMENTS_UPLOAD'
export const LOAD_NEW_DOCUMENTS_UPLOAD_PENDING = 'LOAD_NEW_DOCUMENTS_UPLOAD_PENDING'
export const LOAD_NEW_DOCUMENTS_UPLOAD_FULFILLED = 'LOAD_NEW_DOCUMENTS_UPLOAD_FULFILLED'
export const LOAD_NEW_DOCUMENTS_UPLOAD_REJECTED = 'LOAD_NEW_DOCUMENTS_UPLOAD_REJECTED'

export const LOAD_DOCUMENT_MODELS = 'LOAD_DOCUMENT_MODELS'
export const LOAD_DOCUMENT_MODELS_PENDING = 'LOAD_DOCUMENT_MODELS_PENDING'
export const LOAD_DOCUMENT_MODELS_FULFILLED = 'LOAD_DOCUMENT_MODELS_FULFILLED'
export const LOAD_DOCUMENT_MODELS_REJECTED = 'LOAD_DOCUMENT_MODELS_REJECTED'

export const LOAD_DOCUMENT_TYPES = 'LOAD_DOCUMENT_TYPES'
export const LOAD_DOCUMENT_TYPES_PENDING = 'LOAD_DOCUMENT_TYPES_PENDING'
export const LOAD_DOCUMENT_TYPES_FULFILLED = 'LOAD_DOCUMENT_TYPES_FULFILLED'
export const LOAD_DOCUMENT_TYPES_REJECTED = 'LOAD_DOCUMENT_TYPES_REJECTED'

export const LOAD_DOCUMENT_LANGUAGES = 'LOAD_DOCUMENT_LANGUAGES'
export const LOAD_DOCUMENT_LANGUAGES_PENDING = 'LOAD_DOCUMENT_LANGUAGES_PENDING'
export const LOAD_DOCUMENT_LANGUAGES_FULFILLED = 'LOAD_DOCUMENT_LANGUAGES_FULFILLED'
export const LOAD_DOCUMENT_LANGUAGES_REJECTED = 'LOAD_DOCUMENT_LANGUAGES_REJECTED'

export const LOAD_DOCUMENT_CATEGORIES = 'LOAD_DOCUMENT_CATEGORIES'
export const LOAD_DOCUMENT_CATEGORIES_PENDING = 'LOAD_DOCUMENT_CATEGORIES_PENDING'
export const LOAD_DOCUMENT_CATEGORIES_FULFILLED = 'LOAD_DOCUMENT_CATEGORIES_FULFILLED'
export const LOAD_DOCUMENT_CATEGORIES_REJECTED = 'LOAD_DOCUMENT_CATEGORIES_REJECTED'

export const LOAD_ADMIN_DOCUMENT_MODELS = 'LOAD_ADMIN_DOCUMENT_MODELS'
export const LOAD_ADMIN_DOCUMENT_MODELS_PENDING = 'LOAD_ADMIN_DOCUMENT_MODELS_PENDING'
export const LOAD_ADMIN_DOCUMENT_MODELS_FULFILLED = 'LOAD_ADMIN_DOCUMENT_MODELS_FULFILLED'
export const LOAD_ADMIN_DOCUMENT_MODELS_REJECTED = 'LOAD_ADMIN_DOCUMENT_MODELS_REJECTED'

export const LOAD_TSB_DOCUMENT_LANGUAGES = 'LOAD_TSB_DOCUMENT_LANGUAGES'
export const LOAD_TSB_DOCUMENT_LANGUAGES_PENDING = 'LOAD_TSB_DOCUMENT_LANGUAGES_PENDING'
export const LOAD_TSB_DOCUMENT_LANGUAGES_FULFILLED = 'LOAD_TSB_DOCUMENT_LANGUAGES_FULFILLED'
export const LOAD_TSB_DOCUMENT_LANGUAGES_REJECTED = 'LOAD_TSB_DOCUMENT_LANGUAGES_REJECTED'

export const POST_DOCUMENT = 'POST_DOCUMENT'
export const POST_DOCUMENT_PENDING = 'POST_DOCUMENT_PENDING'
export const POST_DOCUMENT_FULFILLED = 'POST_DOCUMENT_FULFILLED'
export const POST_DOCUMENT_REJECTED = 'POST_DOCUMENT_REJECTED'

export const PUT_DOCUMENT = 'PUT_DOCUMENT'
export const PUT_DOCUMENT_PENDING = 'PUT_DOCUMENT_PENDING'
export const PUT_DOCUMENT_FULFILLED = 'PUT_DOCUMENT_FULFILLED'
export const PUT_DOCUMENT_REJECTED = 'PUT_DOCUMENT_REJECTED'

export const PUT_DOCUMENT_FILE = 'PUT_DOCUMENT_FILE'
export const PUT_DOCUMENT_FILE_PENDING = 'PUT_DOCUMENT_FILE_PENDING'
export const PUT_DOCUMENT_FILE_FULFILLED = 'PUT_DOCUMENT_FILE_FULFILLED'
export const PUT_DOCUMENT_FILE_REJECTED = 'PUT_DOCUMENT_FILE_REJECTED'

export const PUT_DOCUMENT_EXTERNAL_FILE = 'PUT_DOCUMENT_EXTERNAL_FILE'
export const PUT_DOCUMENT_EXTERNAL_FILE_PENDING = 'PUT_DOCUMENT_EXTERNAL_FILE_PENDING'
export const PUT_DOCUMENT_EXTERNAL_FILE_FULFILLED = 'PUT_DOCUMENT_EXTERNAL_FILE_FULFILLED'
export const PUT_DOCUMENT_EXTERNAL_FILE_REJECTED = 'PUT_DOCUMENT_EXTERNAL_FILE_REJECTED'

export const DELETE_DOCUMENT = 'DELETE_DOCUMENT'
export const DELETE_DOCUMENT_PENDING = 'DELETE_DOCUMENT_PENDING'
export const DELETE_DOCUMENT_FULFILLED = 'DELETE_DOCUMENT_FULFILLED'
export const DELETE_DOCUMENT_REJECTED = 'DELETE_DOCUMENT_REJECTED'

export const DELETE_DOCUMENT_FILE = 'DELETE_DOCUMENT_FILE'
export const DELETE_DOCUMENT_FILE_PENDING = 'DELETE_DOCUMENT_FILE_PENDING'
export const DELETE_DOCUMENT_FILE_FULFILLED = 'DELETE_DOCUMENT_FILE_FULFILLED'
export const DELETE_DOCUMENT_FILE_REJECTED = 'DELETE_DOCUMENT_FILE_REJECTED'

export const DELETE_DOCUMENT_EXTERNAL_FILE = 'DELETE_DOCUMENT_EXTERNAL_FILE'
export const DELETE_DOCUMENT_EXTERNAL_FILE_PENDING = 'DELETE_DOCUMENT_EXTERNAL_FILE_PENDING'
export const DELETE_DOCUMENT_EXTERNAL_FILE_FULFILLED = 'DELETE_DOCUMENT_EXTERNAL_FILE_FULFILLED'
export const DELETE_DOCUMENT_EXTERNAL_FILE_REJECTED = 'DELETE_DOCUMENT_EXTERNAL_FILE_REJECTED'

export const CLEAR_DOCUMENTS_MESSAGES = 'CLEAR_DOCUMENTS_MESSAGES'

export function loadDocuments(queryParams, refetch = false, limit) {
  return {
    type: refetch ? LOAD_NEW_DOCUMENTS : LOAD_DOCUMENTS,
    payload: getDocuments(queryParams, limit),
  }
}

export function loadTSBDocuments(queryParams, refatch = false, limit) {
  return {
    type: refatch ? LOAD_NEW_TSB_DOCUMENTS : LOAD_TSB_DOCUMENTS,
    payload: getTSBDocuments(queryParams, limit),
  }
}

export function loadDashboardTSBDocuments(queryParams, limit) {
  return {
    type: LOAD_DASHBOARD_TSB_DOCUMENTS,
    payload: getTSBDocuments(queryParams, limit),
  }
}

export function loadDocumentsUpload(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_DOCUMENTS_UPLOAD : LOAD_DOCUMENTS_UPLOAD,
    payload: getDocumentsUpload(queryParams),
  }
}

export function loadDocumentModels() {
  return {
    type: LOAD_DOCUMENT_MODELS,
    payload: getDocumentModels(),
  }
}

export function loadDocumentTypes() {
  return {
    type: LOAD_DOCUMENT_TYPES,
    payload: getDocumentTypes(),
  }
}

export function loadDocumentLanguages() {
  return {
    type: LOAD_DOCUMENT_LANGUAGES,
    payload: getDocumentLanguages(),
  }
}

export function loadTsbDocumentLanguages() {
  return {
    type: LOAD_TSB_DOCUMENT_LANGUAGES,
    payload: getTsbDocumentLanguages(),
  }
}

export function loadDocumentCategories() {
  return {
    type: LOAD_DOCUMENT_CATEGORIES,
    payload: getDocumentCategories(),
  }
}

export function loadAdminDocumentModels() {
  return {
    type: LOAD_ADMIN_DOCUMENT_MODELS,
    payload: getAdminDocumentModels(),
  }
}

export function createDocument(bodyParams) {
  return {
    type: POST_DOCUMENT,
    payload: postDocument(bodyParams),
  }
}

export function updateDocument(id, bodyParams) {
  return {
    type: PUT_DOCUMENT,
    payload: putDocument(id, bodyParams),
  }
}

export function updateDocumentFile(documentId, fileId, bodyParams) {
  return {
    type: PUT_DOCUMENT_FILE,
    payload: putDocumentFile(documentId, fileId, bodyParams),
    meta: { documentId },
  }
}

export function updateDocumentExternalFile(documentId, fileId, bodyParams) {
  return {
    type: PUT_DOCUMENT_EXTERNAL_FILE,
    payload: putDocumentExternalFile(documentId, fileId, bodyParams),
    meta: { documentId },
  }
}

export function removeDocument(id) {
  return {
    type: DELETE_DOCUMENT,
    payload: deleteDocument(id),
    meta: { id },
  }
}

export function removeDocumentFile(documentId, fileId) {
  return {
    type: DELETE_DOCUMENT_FILE,
    payload: deleteDocumentFile(documentId, fileId),
    meta: { documentId, fileId },
  }
}

export function removeDocumentExternalFile(documentId, fileId) {
  return {
    type: DELETE_DOCUMENT_EXTERNAL_FILE,
    payload: deleteDocumentExternalFile(documentId, fileId),
    meta: { documentId, fileId },
  }
}

export function clearDocumentsMessages() {
  return {
    type: CLEAR_DOCUMENTS_MESSAGES,
  }
}

